import { createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Enums.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance3hlj875zwihx0 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { SerializerFactory1qv9hivitncuv as SerializerFactory } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { enumEntries20mr21zbe3az4 as enumEntries } from '../../../../kotlin-kotlin-stdlib/kotlin/enums/EnumEntries.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import {
  Companion_getInstance3vz87v4c01z2t as Companion_getInstance,
  toDuration7gy6v749ektt as toDuration,
} from '../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_SECONDS_getInstance3jias9ne5z4er as DurationUnit_SECONDS_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { BulkFetcher2m111bjvjns8 as BulkFetcher } from '../../../../lightning-server-kiteui-client/com/lightningkite/lightningserver/networking/BulkFetcher.mjs';
import { LiveApi22p7ep9cwyglni as LiveApi2 } from './LiveApi.mjs';
import { startsWith26w8qjqapeeq6 as startsWith } from '../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializer1hwzc6m64v1op as serializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/Serializers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { PersistentProperty2s7ex88zm8bn9 as PersistentProperty } from '../../../../kiteui-library/com/lightningkite/kiteui/reactive/PersistentProperty.mjs';
import { contains3ue2qo8xhmpf1 as contains } from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_selectedApi() {
  _init_properties_apiOptions_kt__lelycc();
  return selectedApi;
}
var selectedApi;
function _get_$cachedSerializer__te6jhj($this) {
  return $this.ffx_1.f2();
}
function ApiOption$Companion$_anonymous__1rx49s() {
  return createSimpleEnumSerializer('com.crowpay.sdk.ApiOption', values());
}
var ApiOption_Production_instance;
var ApiOption_Staging_instance;
var ApiOption_Dev_instance;
var ApiOption_BSvedin_instance;
var ApiOption_Local_instance;
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.efx_1 = setOf([ApiOption_Local_getInstance(), ApiOption_BSvedin_getInstance(), ApiOption_Dev_getInstance(), ApiOption_Staging_getInstance()]);
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.ffx_1 = lazy(tmp_0, ApiOption$Companion$_anonymous__1rx49s);
      }
      k2a() {
        return _get_$cachedSerializer__te6jhj(this);
      }
      f1c(typeParamsSerializers) {
        return this.k2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  ApiOption_initEntries();
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
function values() {
  return [ApiOption_Production_getInstance(), ApiOption_Staging_getInstance(), ApiOption_Dev_getInstance(), ApiOption_BSvedin_getInstance(), ApiOption_Local_getInstance()];
}
function get_entries() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var ApiOption_entriesInitialized;
function ApiOption_initEntries() {
  if (ApiOption_entriesInitialized)
    return Unit_instance;
  ApiOption_entriesInitialized = true;
  ApiOption_Production_instance = ApiOption().gfx('Production', 0, '      ', 'https://api.app.stoze.io', 'wss://ws.api.app.stoze.io', false);
  ApiOption_Staging_instance = ApiOption().gfx('Staging', 1, 'Staging', 'https://staging.api.app.stoze.io', 'wss://ws.staging.api.app.stoze.io', true);
  ApiOption_Dev_instance = ApiOption().gfx('Dev', 2, 'Dev', 'https://dev.api.app.stoze.io', 'wss://ws.dev.api.app.stoze.io', true);
  ApiOption_BSvedin_instance = ApiOption().gfx('BSvedin', 3, 'BSvedin', 'https://bsvedin.dev.lightningkite.com/server', 'wss://bsvedin.dev.lightningkite.com/server', true);
  ApiOption_Local_instance = ApiOption().gfx('Local', 4, 'Local', 'http://localhost:8080', 'ws://localhost:8080', true);
  Companion_getInstance_0();
}
var $ENTRIES;
var ApiOptionClass;
function ApiOption() {
  if (ApiOptionClass === VOID) {
    class $ extends Enum() {
      static gfx(name, ordinal, apiName, http, ws, testingServer) {
        var $this = this.c4(name, ordinal);
        $this.zfw_1 = apiName;
        $this.afx_1 = http;
        $this.bfx_1 = ws;
        $this.cfx_1 = testingServer;
        return $this;
      }
      dfx() {
        var tmp = this.afx_1 + '/meta/bulk';
        var tmp_0 = this.bfx_1 + '?path=/multiplex';
        // Inline function 'kotlin.time.Companion.seconds' call
        Companion_getInstance();
        var tmp$ret$0 = toDuration(30, DurationUnit_SECONDS_getInstance());
        return new (LiveApi2())(new (BulkFetcher())(tmp, tmp_0, VOID, tmp$ret$0));
      }
      hfx() {
        return (startsWith(this.afx_1, 'https') || startsWith(this.afx_1, 'http://localhost')) && (startsWith(this.bfx_1, 'wss') || startsWith(this.bfx_1, 'https') || startsWith(this.bfx_1, 'http://localhost:') || startsWith(this.bfx_1, 'ws://localhost:'));
      }
    }
    initMetadataForClass($, 'ApiOption', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_0});
    ApiOptionClass = $;
  }
  return ApiOptionClass;
}
function ApiOption_Production_getInstance() {
  ApiOption_initEntries();
  return ApiOption_Production_instance;
}
function ApiOption_Staging_getInstance() {
  ApiOption_initEntries();
  return ApiOption_Staging_instance;
}
function ApiOption_Dev_getInstance() {
  ApiOption_initEntries();
  return ApiOption_Dev_instance;
}
function ApiOption_BSvedin_getInstance() {
  ApiOption_initEntries();
  return ApiOption_BSvedin_instance;
}
function ApiOption_Local_getInstance() {
  ApiOption_initEntries();
  return ApiOption_Local_instance;
}
var properties_initialized_apiOptions_kt_513xx6;
function _init_properties_apiOptions_kt__lelycc() {
  if (!properties_initialized_apiOptions_kt_513xx6) {
    properties_initialized_apiOptions_kt_513xx6 = true;
    var tmp0 = 'apiOption';
    // Inline function 'com.lightningkite.kiteui.reactive.PersistentProperty' call
    var defaultValue = getDefaultServerBackend();
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_0 = serializer(createKType(getKClass(ApiOption()), arrayOf([]), false));
    var tmp$ret$1 = isInterface(this_0, KSerializer()) ? this_0 : THROW_CCE();
    selectedApi = PersistentProperty().qd8(tmp0, defaultValue, tmp$ret$1);
  }
}
function getDefaultServerBackend() {
  var host = window.location.hostname;
  return contains(host, 'staging.app') ? ApiOption_Staging_getInstance() : contains(host, 'dev.app') ? ApiOption_Dev_getInstance() : contains(host, 'bsvedin') ? ApiOption_BSvedin_getInstance() : contains(host, 'localhost') ? ApiOption_Local_getInstance() : ApiOption_Production_getInstance();
}
//region block: exports
export {
  get_entries as get_entries12jrtr1kr2cjq,
  getDefaultServerBackend as getDefaultServerBackend2jor6mvf4ze21,
  get_selectedApi as get_selectedApi2skzkr2pn0lot,
  ApiOption_Dev_getInstance as ApiOption_Dev_getInstance1m81jm7ijrt5y,
  ApiOption_Local_getInstance as ApiOption_Local_getInstance3fvnpo9ha9ael,
  ApiOption_Production_getInstance as ApiOption_Production_getInstanceca14cdl7io88,
  Companion_getInstance_0 as Companion_getInstancecudcwq8yu3m7,
};
//endregion

//# sourceMappingURL=apiOptions.mjs.map
